var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "PencilEdit",
    {
      attrs: {
        fieldLabel: _vm.$t("project.dlpDate"),
        displayValue: _vm.dlpDateFieldTools.displayField.value,
        canEdit: _vm.dlpDateFieldTools.canEdit.value,
      },
      on: {
        closePencil: _vm.dlpDateFieldTools.updateFc,
        openPencil: _vm.updateDatePickerValue,
      },
    },
    [
      _c("DatePicker", {
        attrs: {
          disabled: _vm.disableDlpdDate,
          calendarButton: true,
          calendarButtonIcon: "fa fa-calendar",
          value: _vm.datePickerValue,
        },
        on: {
          selected: function (val) {
            return _vm.dlpDateFieldTools.setPendingField(val)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }